import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  /* eslint-disable @typescript-eslint/no-non-null-assertion */
  public get<T>(key: string): T | null {
    return <T>JSON.parse(localStorage.getItem(key)!);
  }

  public remove(key: string): void {
    localStorage.removeItem(key);
  }

  public set(key: string, data: boolean): void {
    localStorage.setItem(key, JSON.stringify(data));
  }
}
